if(typeof jQuery=='undefined'){
	var headTag = document.getElementsByTagName("head")[0];
	var jqTag = document.createElement('script');
	jqTag.type = 'text/javascript';
	jqTag.src = 'https://code.jquery.com/jquery-1.12.4.min.js';

	jqTag.addEventListener('load', function(){
		init();
	})

	headTag.appendChild(jqTag);
	
} else {
	init();
	
}
var headTag = document.getElementsByTagName("head")[0];
var font = document.createElement('link');
font.href = 'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap';
font.rel = 'stylesheet';
headTag.appendChild(font);

function init(){

	(function( $ ) {
  		$(function() {

  			let domain = '.bonebrox.ch';
    		let b = $('<div class="cookieConsentBanner"></div>');
    		let cookies = document.cookie.split(';');

    		let hours = 24*10;
    		let date = new Date();
       		date.setTime(date.getTime()+(hours*60*60*1000));
        	let expires = "; expires="+date.toGMTString();

        	let cookies_markting = ['_shopify_fs','_shopify_s','_shopify_sa_t','_shopify_uniq','_shopify_visit','_shopify_y','_y','tracked_start_checkout','_ga', '_ga','_gid','_gat','__atuvc','__atuvs','__atuvc','__utma','__cfdui'];
			let cookies_statistics = ['_gads','IDE','_s','collect','GPS','PREF','BizoID','_fbp','_fb','ac_enable_tracking','hjid'];

			let disableMarketing = true;
			let disableStatistic = true;


			function removeCookie( cookieStr ){

				let date = new Date();
       			let expires = date.toGMTString();

				let cookie = cookieStr.split('=')[0].trim() +'=; Domain=' + domain + '; Path=/; expires='+expires;
    			document.cookie = cookie;
    			document.cookie = ' '+cookie;

			}
         

    		function removeCookies(){
              
              	cookies = document.cookie.split(';');
    			
    			for ( let i in cookies ){
	    			if ( cookies[i].includes('ilCook') ){
	    				if ( cookies[i].includes('marketing-1') ) disableMarketing = false;
	    				if ( cookies[i].includes('statistic-1') ) disableStatistic = false;
	    			}
    			}

                
    			
    			for ( let i in cookies ){

    				if ( disableMarketing == true ){
    					for ( let i1 in cookies_markting ){
    						if ( cookies[i].includes( cookies_markting[i1] ) ) removeCookie( cookies[i] );
    						
    					}
    				}

    				if ( disableStatistic == true ){
    					for ( let i1 in cookies_statistics ){
    						if ( cookies[i].includes( cookies_statistics[i1] ) ) removeCookie( cookies[i] );
    					}
    				}
    				
    			}

    			window.setTimeout( removeCookies, 5000 );

    		}

    		for ( let i in cookies ){
    			if ( cookies[i].includes('ilCook') ){
    				if ( cookies[i].includes('marketing-1') ) disableMarketing = false;
    				if ( cookies[i].includes('statistic-1') ) disableStatistic = false;

    				if ( disableMarketing || disableStatistic ) removeCookies();
                  	sendTagManagerEvents();
    				return;
    			}
    		}

            function sendTagManagerEvents() {
              if (typeof dataLayer !== 'undefined') {
                if (!disableStatistic) {
                  dataLayer.push({'event': 'cookieconsent_statistic'}); 
                }
                if (!disableMarketing) {                      
                  dataLayer.push({'event': 'cookieconsent_marketing'}); 
                }                    
              }
            }

    		$('body').append(  b );
    		$('body').addClass(  'cookieConsentBannerDisableScroll' );

    		


    		b.load('//cdn.shopify.com/s/files/1/0250/8934/3591/t/2/assets/cookie_app.html?v=158681449188946263971611825230', function(){


    			function hideCC(){
    				$('body').removeClass(  'cookieConsentBannerDisableScroll' );
    				$('.cookieConsentBanner').hide();
    			}
          
                function onClick() {
    				let cookie = 'ilCook=statistic-'+( $('[data-area="statistic"]').hasClass('checked') ? 1 : 0 )+'--marketing-'+( $('[data-area="marketing"]').hasClass('checked') ? 1 : 0 );
    				cookie += '; Domain='+domain+'; Path=/; expires='+expires
    				document.cookie = cookie;

    				removeCookies();
                  	sendTagManagerEvents();
    				hideCC();
                }
          

    			$('.details_link').on('click', function(){
    				$('.details').toggleClass('show');
    			})

    			$('.cookieConsentBanner').on('click', function( e){
    				if ( $(e.target).hasClass('cookieConsentBanner') ){
    					hideCC();
    				}
    			})

    			$('.check').on('click', function(){
    				if ( $(this).hasClass('notremarkable') ) return;

    				$(this).toggleClass('checked');
    			})

    			$('.selectall').on('click', function(){
    				$('.check').addClass('checked');
                  	onClick();
    			})


    			$('.confirm').on('click', onClick)


    		});


  		});
	})(jQuery);
	
}